import moment from 'moment';
export default function CreateJobScheduleDirective() {
  return {
    restrict: 'E',
    template: require('./_form-schedule.html'),
    scope: {
      schedule: '=',
      edit: '=',
      dropDowntimes: '=',
      submitted: '='
    },
    controller: CreateJobScheduleController
  };

  function CreateJobScheduleController($scope, gettextCatalog) {
    'ngInject';
    $scope.$on('totalEmails', function(event, totalEmails) {
      $scope.maxEmails = totalEmails.length;
      $scope.$emit('totalEmails', {
        length: $scope.maxEmails
      });
    });

    $scope.time1 = $scope.schedule.deliveryTime
      ? moment($scope.schedule.deliveryTime.dateTime).toDate()
      : moment('May 19, 2016 00:00:00').toDate(); // only the hours and minutes are cared
    let today = moment().toDate();
    today.setHours(0, 0);

    $scope.showMeridian = true;
    $scope.startDate = moment().toDate();
    $scope.endDate = moment().toDate();

    $scope.hstep = 1;
    $scope.mstep = 15;
    $scope.options = {
      hstep: [1, 2, 3],
      mstep: [1, 5, 10, 15, 25, 30]
    };
    $scope.ismeridian = true;
    $scope.toggleMode = function() {
      $scope.ismeridian = !$scope.ismeridian;
    };

    $scope.changed = function() {
      $scope.schedule.deliveryTime.dateTime = $scope.time1;
    };

    $scope.clear = function() {
      $scope.schedule.deliveryTime.dateTime = null;
    };

    //Constants
    $scope.dateRangeOptions = [
      {
        label: gettextCatalog.getString('Days'),
        value: 'day'
      },
      {
        label: gettextCatalog.getString('Weeks'),
        value: 'week'
      },
      {
        label: gettextCatalog.getString('Months'),
        value: 'month'
      },
      {
        label: gettextCatalog.getString('Years'),
        value: 'year'
      }
    ];

    function prefetchTime() {
      $scope.schedule.deliveryTime = {};
      $scope.schedule.deliveryTime.dateTime = $scope.time1;
    }

    $scope.formats = ['MM-dd-yyyy', 'yyyy/MM/dd', 'MM/dd/yyyy', 'dd.MM.yyyy', 'shortDate'];
    $scope.format = $scope.formats[1];

    // today.setHours(0,0);
    let minDate = $scope.schedule.deliveryTime ? $scope.schedule.deliveryTime.dateTime : today;
    if (minDate > today) {
      minDate = today;
    }
    $scope.schedule.minDate = minDate;
    $scope.schedule.startDate = moment($scope.schedule.startDate).toDate();
    if ($scope.schedule.startDate === 'Invalid Date') {
      $scope.schedule.startDate = undefined;
    } else {
      $scope.schedule.startDate.setHours(0, 0);
      $scope.schedule.minDate.setHours(0, 0);
    }

    $scope.dateOptions = {
      formatYear: 'yy',
      maxDate: moment()
        .add(5, 'years')
        .toDate(),
      minDate: moment(minDate).toDate(),
      startingDay: 1
    };

    $scope.openStart = function() {
      $scope.startOpened = true;
    };

    $scope.openEnd = function() {
      $scope.endOpened = true;
    };
    prefetchTime();
  }
}
